import React from 'react';
import { motion } from 'framer-motion';

const Home = () => {
  return (
    <div 
      className="pt-10 pb-12 bg-cover bg-center bg-no-repeat text-yellow-300"
      style={{ backgroundImage: "url('/images/fondo1.png')" }}
    >
      <div className="container mx-auto px-5">

        {/* SECCIÓN PRINCIPAL */}
        <motion.section 
          className="text-center py-20"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.div transition={{ duration: 0.4 }}>
            <motion.img
              src="/images/logo.png"
              alt="Logo de la empresa"
              className="w-[500px] h-[500px] object-contain mx-auto"
            />
          </motion.div>

          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-red-400 to-yellow-400 bg-clip-text text-transparent">
            Bienvenido
          </h1>
          
        </motion.section>

         {/* SECCIÓN ¿QUIÉNES SOMOS? */}
        <motion.section 
          className="grid md:grid-cols-1 gap-8 py-16 max-w-3xl mx-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          <motion.div 
            className="bg-black/20 backdrop-blur-md rounded-2xl p-8 text-center border border-red-500/30 cursor-default"
            whileHover={{ 
              y: -10, 
              scale: 1.02,
              backgroundColor: '#00000040',
              borderColor: '#ef4444',
              boxShadow: '0 15px 30px rgba(239, 68, 68, 0.3)'
            }}
            transition={{ duration: 0.4, type: 'spring' }}
          >
            <h3 className="text-3xl font-bold mb-4 text-yellow-300">
              ¿Quiénes Somos?
            </h3>

            <p className="text-[#F5F3F2] text-lg leading-relaxed">
              Somos especialistas en trabajos esotéricos enfocados en el amor, tales como amarres, endulzamientos, alejamientos, unión de parejas y armonización energética.
              Cada ritual se realiza con total discreción, respeto y seriedad.
            </p>
          </motion.div>
        </motion.section>

        {/* ⭐ SECCIÓN DE PROMOCIONES ⭐ */}
        <motion.section
          className="py-16"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-center text-5xl font-bold mb-12 text-yellow-300 drop-shadow-[0_0_20px_#ff0000]">
            ✨ Promociones Especiales ✨
          </h2>

          <div className="grid md:grid-cols-3 gap-10 max-w-5xl mx-auto">

            {/* PROMO 1 */}
            <motion.div 
              className="bg-black/30 backdrop-blur-md border border-yellow-300/30 p-10 rounded-2xl text-center shadow-lg"
              whileHover={{
                scale: 1.05,
                boxShadow: "0 0 25px rgba(255, 200, 0, 0.5)",
                borderColor: "#facc15"
              }}
            >
              <h3 className="text-2xl font-bold text-yellow-300 mb-3">Primera Lectura Gratis</h3>
              <p className="text-white leading-relaxed">
                Tu primera lectura de tarot es completamente <span className="text-yellow-400 font-semibold">GRATIS</span>.
              </p>
            </motion.div>

            {/* PROMO 2 */}
            <motion.div 
              className="bg-black/30 backdrop-blur-md border border-red-400/30 p-6 rounded-2xl text-center shadow-lg"
              whileHover={{
                scale: 1.05,
                boxShadow: "0 0 25px rgba(255, 0, 0, 0.5)",
                borderColor: "#ef4444"
              }}
            >
              <h3 className="text-2xl font-bold text-red-400 mb-3">Amuleto Protector Gratis</h3>
              <p className="text-white leading-relaxed">
                En tu <span className="text-red-300 font-semibold">segunda consulta</span> de tarot recibes un amuleto protector sin costo.
              </p>
            </motion.div>

            {/* PROMO 3 */}
            <motion.div 
              className="bg-black/30 backdrop-blur-md border border-purple-400/30 p-6 rounded-2xl text-center shadow-lg"
              whileHover={{
                scale: 1.05,
                boxShadow: "0 0 25px rgba(168, 85, 247, 0.5)",
                borderColor: "#a855f7"
              }}
            >
              <h3 className="text-2xl font-bold text-purple-400 mb-3">Abundancia 2026</h3>
              <p className="text-white leading-relaxed">
                En la compra de tus veladoras especiales para <span className="font-semibold">2026</span>, recibe gratis las{" "}
                <span className="text-purple-300 font-semibold">Semillas de la Abundancia</span>.
              </p>
            </motion.div>

          </div>
        </motion.section>
      </div>
    </div>
  );
};

export default Home;
